import React, { useState, useContext } from "react";
import {
  Alert,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import { ArrowBack, ArrowForward } from "@mui/icons-material";
import {
  InstitutionType,
  coeParticipants,
  degAwardingParticipants,
  ieiParticipants,
  institutions,
  otherParticipants,
  polyTechnicParticipants,
  states,
  universityParticipants,
} from "./institutions";
import Swal from "sweetalert2";
import { Modal } from "react-bootstrap";
import { httpService } from "../httpService";
import { LoadingButton } from "@mui/lab";
import CountdownTimer from "../components/CountdownTimer";
import { AlertContext } from "../contexts/AlertContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendar,
  faClock,
  faHouse,
} from "@fortawesome/free-solid-svg-icons";
import { eventBio } from "./info";
import HomeBanner from "../components/HomeBanner";
export default function HomePage() {
  const [registrationData, setRegistrationData] = useState({});
  const [participant1, setParticipant1] = useState({});
  const [participant2, setParticipant2] = useState({});
  const [participant3, setParticipant3] = useState({});
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [participant1Error, setParticipant1Error] = useState(false);
  const [participant2Error, setParticipant2Error] = useState(false);
  const [participant3Error, setParticipant3Error] = useState(false);
  const { setAlertData } = useContext(AlertContext);
  const [fetching, setFetching] = useState(false);
  const [code, setCode] = useState("");
  // const handleChange = (e) => {
  //   setRegistrationData({
  //     ...registrationData,
  //     [e.target.name]: e.target.value,
  //   });
  // };

  const participant3Change = (e) => {
    setParticipant3({
      ...participant3,
      [e.target.name]: e.target.value,
    });
  };
  const participant2Change = (e) => {
    setParticipant2({
      ...participant2,
      [e.target.name]: e.target.value,
    });
  };

  const participant1Change = (e) => {
    setParticipant1({
      ...participant1,
      [e.target.name]: e.target.value,
    });
  };
  const handleShow = (e) => {
    e.preventDefault();
    if (participant1.role === participant2.role) {
      return Swal.fire({
        icon: "warning",
        title: "Duplicate Role Found",
        text: "Both participants cannot have the same role",
      });
    }
    if (participant1.roleCategory === participant2.roleCategory) {
      return Swal.fire({
        icon: "warning",
        title: "Invalid Role Selection",
        text: "Either of both particiants must be an institution head and any other role",
      });
    }
    setShow(true);
  };
  const handleClose = () => setShow(false);

  const registerParticipant = () => {
    Swal.fire({
      icon: "question",
      title: "Proceed to next stage?",

      showCancelButton: true,
    }).then(async (e) => {
      if (e.isConfirmed) {
        setLoading(true);
        const path = "registerparticipant";

        const { data, error } = await httpService.post(path, {
          participant1: { ...participant1, ...registrationData },
          participant2: { ...participant2, ...registrationData },
          participant3: { ...participant3, ...registrationData },
        });

        if (data) {
          window.location.assign(`/printout/${data}`);
        }

        if (error) {
          setAlertData({
            open: true,
            message: error,
            severity: "error",
          });
        }

        setLoading(false);
        setShow(false);
      }
    });
  };

  const retrieveRegistration = async (e) => {
    e.preventDefault();
    setFetching(true);
    const { data, error } = await httpService.post("retrieveregistration", {
      code,
    });

    if (data) window.location.assign(`/printout/${data}`);
    if (error) {
      setAlertData({
        open: true,
        message: error,
        severity: "error",
      });
    }
    setFetching(false);
  };
  return (
    <div>
      <HomeBanner />
      <div className="mt-4 mb-4 p-3">
        <div className="d-flex justify-content-center">
          {/* <CountdownTimer /> */}
        </div>

        <form onSubmit={handleShow}>
          <div className="col-lg-6 mb-5">
            <div className="mb-3">
              <Typography variant="h4" fontWeight={700} color="GrayText">
                Institution
              </Typography>
            </div>
            <div className="mb-3">
              <TextField
                select
                fullWidth
                required
                label="State"
                helperText="Select state of institution"
                onChange={(e) => {
                  setRegistrationData({
                    ...registrationData,
                    state: e.target.value.ST_NAME,
                    stateId: e.target.value.ST_ID,
                    region: e.target.value.REGION,
                  });
                }}
              >
                {states.map((c, i) => (
                  <MenuItem key={i} value={c}>
                    {c.ST_NAME}
                  </MenuItem>
                ))}
              </TextField>
            </div>
            <div className="mb-3">
              <TextField
                select
                required
                fullWidth
                label="Institution Category"
                helperText="Select Institution category"
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    category: e.target.value,
                  })
                }
              >
                {InstitutionType.map((c) => (
                  <MenuItem value={c}>{c}</MenuItem>
                ))}
              </TextField>
            </div>
            <div className="mb-3">
              <TextField
                select
                required
                helperText={"Select Institution"}
                label="Institution"
                fullWidth
                onChange={(e) =>
                  setRegistrationData({
                    ...registrationData,
                    institution: e.target.value.INName,
                    institutionId: e.target.value.INID,
                  })
                }
              >
                {institutions
                  .filter((c) => {
                    return (
                      c.category === registrationData.category &&
                      c.InSt === registrationData.stateId
                    );
                  })
                  .map((d) => (
                    <MenuItem value={d}> {d.INName}</MenuItem>
                  ))}
              </TextField>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4">
              <Typography
                variant="h4"
                gutterBottom
                fontWeight={700}
                color="GrayText"
              >
                Participant I
              </Typography>
              <Alert severity="info">
                Usually the head of Institution. VC, Rector or Provost
              </Alert>
              <div className="mb-3">
                <div>
                  {registrationData.institution && registrationData.category ? (
                    <>
                      {registrationData.category === InstitutionType[0] ? (
                        <TextField
                          fullWidth
                          label="Role"
                          helperText="Select Roles"
                          select
                          onChange={(e) =>
                            e.target.value.role === "Others"
                              ? setParticipant1({
                                  ...participant1,
                                  otherRoles: true,
                                })
                              : setParticipant1({
                                  ...participant1,
                                  role: e.target.value.role,
                                  roleCategory: e.target.value.category,
                                  otherRoles: false,
                                })
                          }
                        >
                          {universityParticipants.map((c) => (
                            <MenuItem value={c}>{c.role}</MenuItem>
                          ))}
                        </TextField>
                      ) : null}
                      {registrationData.category === InstitutionType[1] ? (
                        <TextField
                          fullWidth
                          label="Role"
                          helperText="Select Roles"
                          select
                          onChange={(e) =>
                            e.target.value.role === "Others"
                              ? setParticipant1({
                                  ...participant1,
                                  otherRoles: true,
                                })
                              : setParticipant1({
                                  ...participant1,
                                  role: e.target.value.role,
                                  roleCategory: e.target.value.category,
                                  otherRoles: false,
                                })
                          }
                        >
                          {degAwardingParticipants.map((c) => (
                            <MenuItem value={c}>{c.role}</MenuItem>
                          ))}
                        </TextField>
                      ) : null}
                      {registrationData.category === InstitutionType[2] ? (
                        <TextField
                          fullWidth
                          label="Role"
                          helperText="Select Roles"
                          select
                          onChange={(e) =>
                            e.target.value.role === "Others"
                              ? setParticipant1({
                                  ...participant1,
                                  otherRoles: true,
                                })
                              : setParticipant1({
                                  ...participant1,

                                  role: e.target.value.role,
                                  roleCategory: e.target.value.category,
                                  otherRoles: false,
                                })
                          }
                        >
                          {polyTechnicParticipants.map((c) => (
                            <MenuItem value={c}>{c.role}</MenuItem>
                          ))}
                        </TextField>
                      ) : null}
                      {registrationData.category === InstitutionType[3] ? (
                        <TextField
                          fullWidth
                          label="Role"
                          helperText="Select Roles"
                          select
                          onChange={(e) =>
                            e.target.value.role === "Others"
                              ? setParticipant1({
                                  ...participant1,
                                  otherRoles: true,
                                })
                              : setParticipant1({
                                  ...participant1,

                                  role: e.target.value.role,
                                  roleCategory: e.target.value.category,
                                  otherRoles: false,
                                })
                          }
                        >
                          {coeParticipants.map((c) => (
                            <MenuItem value={c}>{c.role}</MenuItem>
                          ))}
                        </TextField>
                      ) : null}{" "}
                      {registrationData.category === InstitutionType[4] ? (
                        <TextField
                          fullWidth
                          label="Role"
                          helperText="Select Roles"
                          select
                          onChange={(e) =>
                            e.target.value.role === "Others"
                              ? setParticipant1({
                                  ...participant1,
                                  otherRoles: true,
                                })
                              : setParticipant1({
                                  ...participant1,

                                  role: e.target.value.role,
                                  roleCategory: e.target.value.category,
                                  otherRoles: false,
                                })
                          }
                        >
                          {ieiParticipants.map((c) => (
                            <MenuItem value={c}>{c.role}</MenuItem>
                          ))}
                        </TextField>
                      ) : null}
                      {participant1.otherRoles === true ? (
                        <FormControl>
                          <FormLabel>Select Role</FormLabel>
                          <RadioGroup
                            onChange={(e) =>
                              setParticipant1({
                                ...participant1,
                                role: e.target.value,
                                roleCategory: "B",
                              })
                            }
                          >
                            {otherParticipants.map((c) => (
                              <FormControlLabel
                                label={c.role}
                                value={c.role}
                                control={<Radio />}
                              />
                            ))}
                          </RadioGroup>
                        </FormControl>
                      ) : null}
                    </>
                  ) : null}
                </div>
              </div>
              <div className="mb-3">
                <TextField
                  required
                  name="title"
                  label="Title"
                  select
                  onChange={participant1Change}
                  fullWidth
                >
                  <MenuItem value="Prof.">Prof.</MenuItem>
                  <MenuItem value="Dr.">Dr.</MenuItem>
                  <MenuItem value="Mr.">Mr.</MenuItem>
                  <MenuItem value="Mrs.">Mrs.</MenuItem>
                  <MenuItem value="Ms.">Ms.</MenuItem>
                </TextField>
              </div>
              <div className="mb-3">
                <TextField
                  label="First Name"
                  name="firstName"
                  required
                  onChange={participant1Change}
                  fullWidth
                />
              </div>
              <div className="mb-3">
                <TextField
                  label="Last Name"
                  fullWidth
                  required
                  name="lastName"
                  onChange={participant1Change}
                />
              </div>
              <div className="mb-3">
                <TextField
                  label="Official Email Address"
                  fullWidth
                  required
                  name="emailAddress"
                  type="email"
                  onChange={participant1Change}
                />
              </div>
              <div className="mb-3">
                <TextField
                  error={participant1Error}
                  label="Phone Number"
                  fullWidth
                  required
                  name="phoneNumber"
                  onChange={(e) => {
                    if (e.target.value.charAt(0) === "0") {
                      participant1Change(e);
                    } else e.target.value = "";
                  }}
                  helperText={
                    participant1Error
                      ? "Fields don't match"
                      : "Format should be 08123456789. Not +234"
                  }
                />
              </div>
              <div className="mb-3">
                <TextField
                  error={participant1Error}
                  label="Confirm Phone Number"
                  fullWidth
                  required
                  name="phoneNumber"
                  helperText={participant1Error ? "Fields don't match" : null}
                  onBlur={(e) => {
                    setParticipant1Error(
                      !(e.target.value === participant1.phoneNumber)
                    );
                  }}
                />
              </div>
            </div>

            <div className="col-lg-4">
              <Typography
                variant="h4"
                gutterBottom
                fontWeight={700}
                color="GrayText"
              >
                Participant II
              </Typography>
              <Alert severity="info">
                Usually any other institution official e.g Registrar, Head of
                ICT
              </Alert>
              <div className="mb-3">
                {registrationData.institution && registrationData.category ? (
                  <>
                    {registrationData.category === InstitutionType[0] ? (
                      <TextField
                        fullWidth
                        label="Role"
                        helperText="Select Roles"
                        select
                        onChange={(e) =>
                          e.target.value.role === "Others"
                            ? setParticipant2({
                                ...participant2,
                                otherRoles: true,
                              })
                            : setParticipant2({
                                ...participant2,
                                role: e.target.value.role,
                                roleCategory: e.target.value.category,
                                otherRoles: false,
                              })
                        }
                      >
                        {universityParticipants.map((c) => (
                          <MenuItem value={c}>{c.role}</MenuItem>
                        ))}
                      </TextField>
                    ) : null}
                    {registrationData.category === InstitutionType[1] ? (
                      <TextField
                        fullWidth
                        label="Role"
                        helperText="Select Roles"
                        select
                        onChange={(e) =>
                          e.target.value.role === "Others"
                            ? setParticipant2({
                                ...participant2,
                                otherRoles: true,
                              })
                            : setParticipant2({
                                ...participant2,
                                role: e.target.value.role,
                                roleCategory: e.target.value.category,
                                otherRoles: false,
                              })
                        }
                      >
                        {degAwardingParticipants.map((c) => (
                          <MenuItem value={c}>{c.role}</MenuItem>
                        ))}
                      </TextField>
                    ) : null}
                    {registrationData.category === InstitutionType[2] ? (
                      <TextField
                        fullWidth
                        label="Role"
                        helperText="Select Roles"
                        select
                        onChange={(e) =>
                          e.target.value.role === "Others"
                            ? setParticipant2({
                                ...participant2,
                                otherRoles: true,
                              })
                            : setParticipant2({
                                ...participant2,

                                role: e.target.value.role,
                                roleCategory: e.target.value.category,
                                otherRoles: false,
                              })
                        }
                      >
                        {polyTechnicParticipants.map((c) => (
                          <MenuItem value={c}>{c.role}</MenuItem>
                        ))}
                      </TextField>
                    ) : null}
                    {registrationData.category === InstitutionType[3] ? (
                      <TextField
                        fullWidth
                        label="Role"
                        helperText="Select Roles"
                        select
                        onChange={(e) =>
                          e.target.value.role === "Others"
                            ? setParticipant2({
                                ...participant2,
                                otherRoles: true,
                              })
                            : setParticipant2({
                                ...participant2,

                                role: e.target.value.role,
                                roleCategory: e.target.value.category,
                                otherRoles: false,
                              })
                        }
                      >
                        {coeParticipants.map((c) => (
                          <MenuItem value={c}>{c.role}</MenuItem>
                        ))}
                      </TextField>
                    ) : null}{" "}
                    {registrationData.category === InstitutionType[4] ? (
                      <TextField
                        fullWidth
                        label="Role"
                        helperText="Select Roles"
                        select
                        onChange={(e) =>
                          e.target.value.role === "Others"
                            ? setParticipant2({
                                ...participant2,
                                otherRoles: true,
                              })
                            : setParticipant2({
                                ...participant2,

                                role: e.target.value.role,
                                roleCategory: e.target.value.category,
                                otherRoles: false,
                              })
                        }
                      >
                        {ieiParticipants.map((c) => (
                          <MenuItem value={c}>{c.role}</MenuItem>
                        ))}
                      </TextField>
                    ) : null}
                    {participant2.otherRoles === true ? (
                      <FormControl>
                        <FormLabel>Select Role</FormLabel>
                        <RadioGroup
                          onChange={(e) =>
                            setParticipant2({
                              ...participant2,
                              role: e.target.value,
                              roleCategory: "B",
                            })
                          }
                        >
                          {otherParticipants.map((c) => (
                            <FormControlLabel
                              label={c.role}
                              value={c.role}
                              control={<Radio />}
                            />
                          ))}
                        </RadioGroup>
                      </FormControl>
                    ) : null}
                  </>
                ) : null}
              </div>
              <div className="mb-3">
                <TextField
                  name="title"
                  onChange={participant2Change}
                  label="Title"
                  select
                  fullWidth
                >
                  <MenuItem value="Prof.">Prof.</MenuItem>
                  <MenuItem value="Dr.">Dr.</MenuItem>
                  <MenuItem value="Mr.">Mr.</MenuItem>
                  <MenuItem value="Mrs.">Mrs.</MenuItem>
                  <MenuItem value="Ms.">Ms.</MenuItem>
                </TextField>
              </div>
              <div className="mb-3">
                <TextField
                  label="First Name"
                  name="firstName"
                  onChange={participant2Change}
                  fullWidth
                />
              </div>
              <div className="mb-3">
                <TextField
                  label="Last Name"
                  fullWidth
                  name="lastName"
                  onChange={participant2Change}
                />
              </div>
              <div className="mb-3">
                <TextField
                  label="Official Email Address"
                  fullWidth
                  name="emailAddress"
                  type="email"
                  onChange={participant2Change}
                />
              </div>
              <div className="mb-3">
                <TextField
                  error={participant2Error}
                  label="Phone Number"
                  fullWidth
                  name="phoneNumber"
                  onChange={(e) => {
                    if (e.target.value.charAt(0) === "0") {
                      participant2Change(e);
                    } else e.target.value = "";
                  }}
                  helperText={
                    participant2Error
                      ? "Fields don't match"
                      : "Format should be 08123456789. Not +234"
                  }
                />
              </div>
              <div className="mb-3">
                <TextField
                  error={participant2Error}
                  label="Confirm Phone Number"
                  fullWidth
                  name="phoneNumber"
                  helperText={participant2Error ? "Fields don't match" : null}
                  onBlur={(e) => {
                    setParticipant2Error(
                      !(e.target.value === participant2.phoneNumber)
                    );
                  }}
                />
              </div>
            </div>

            <div className="col-lg-4">
              <Typography
                variant="h4"
                gutterBottom
                fontWeight={700}
                color="GrayText"
              >
                Participant III
              </Typography>
              <Alert severity="info">
                Usually any other institution official e.g Registrar, Head of
                ICT
              </Alert>
              <div className="mb-3">
                {registrationData.institution && registrationData.category ? (
                  <>
                    {registrationData.category === InstitutionType[0] ? (
                      <TextField
                        fullWidth
                        label="Role"
                        helperText="Select Roles"
                        select
                        onChange={(e) =>
                          e.target.value.role === "Others"
                            ? setParticipant3({
                                ...participant3,
                                otherRoles: true,
                              })
                            : setParticipant3({
                                ...participant3,
                                role: e.target.value.role,
                                roleCategory: e.target.value.category,
                                otherRoles: false,
                              })
                        }
                      >
                        {universityParticipants.map((c) => (
                          <MenuItem value={c}>{c.role}</MenuItem>
                        ))}
                      </TextField>
                    ) : null}
                    {registrationData.category === InstitutionType[1] ? (
                      <TextField
                        fullWidth
                        label="Role"
                        helperText="Select Roles"
                        select
                        onChange={(e) =>
                          e.target.value.role === "Others"
                            ? setParticipant2({
                                ...participant3,
                                otherRoles: true,
                              })
                            : setParticipant2({
                                ...participant3,
                                role: e.target.value.role,
                                roleCategory: e.target.value.category,
                                otherRoles: false,
                              })
                        }
                      >
                        {degAwardingParticipants.map((c) => (
                          <MenuItem value={c}>{c.role}</MenuItem>
                        ))}
                      </TextField>
                    ) : null}
                    {registrationData.category === InstitutionType[2] ? (
                      <TextField
                        fullWidth
                        label="Role"
                        helperText="Select Roles"
                        select
                        onChange={(e) =>
                          e.target.value.role === "Others"
                            ? setParticipant3({
                                ...participant3,
                                otherRoles: true,
                              })
                            : setParticipant3({
                                ...participant3,

                                role: e.target.value.role,
                                roleCategory: e.target.value.category,
                                otherRoles: false,
                              })
                        }
                      >
                        {polyTechnicParticipants.map((c) => (
                          <MenuItem value={c}>{c.role}</MenuItem>
                        ))}
                      </TextField>
                    ) : null}
                    {registrationData.category === InstitutionType[3] ? (
                      <TextField
                        fullWidth
                        label="Role"
                        helperText="Select Roles"
                        select
                        onChange={(e) =>
                          e.target.value.role === "Others"
                            ? setParticipant3({
                                ...participant3,
                                otherRoles: true,
                              })
                            : setParticipant3({
                                ...participant3,

                                role: e.target.value.role,
                                roleCategory: e.target.value.category,
                                otherRoles: false,
                              })
                        }
                      >
                        {coeParticipants.map((c) => (
                          <MenuItem value={c}>{c.role}</MenuItem>
                        ))}
                      </TextField>
                    ) : null}{" "}
                    {registrationData.category === InstitutionType[4] ? (
                      <TextField
                        fullWidth
                        label="Role"
                        helperText="Select Roles"
                        select
                        onChange={(e) =>
                          e.target.value.role === "Others"
                            ? setParticipant3({
                                ...participant3,
                                otherRoles: true,
                              })
                            : setParticipant3({
                                ...participant3,

                                role: e.target.value.role,
                                roleCategory: e.target.value.category,
                                otherRoles: false,
                              })
                        }
                      >
                        {ieiParticipants.map((c) => (
                          <MenuItem value={c}>{c.role}</MenuItem>
                        ))}
                      </TextField>
                    ) : null}
                    {participant3.otherRoles === true ? (
                      <FormControl>
                        <FormLabel>Select Role</FormLabel>
                        <RadioGroup
                          onChange={(e) =>
                            setParticipant3({
                              ...participant3,
                              role: e.target.value,
                              roleCategory: "C",
                            })
                          }
                        >
                          {otherParticipants.map((c) => (
                            <FormControlLabel
                              label={c.role}
                              value={c.role}
                              control={<Radio />}
                            />
                          ))}
                        </RadioGroup>
                      </FormControl>
                    ) : null}
                  </>
                ) : null}
              </div>
              <div className="mb-3">
                <TextField
                  name="title"
                  onChange={participant3Change}
                  // required
                  label="Title"
                  select
                  fullWidth
                >
                  <MenuItem value="Prof.">Prof.</MenuItem>
                  <MenuItem value="Dr.">Dr.</MenuItem>
                  <MenuItem value="Mr.">Mr.</MenuItem>
                  <MenuItem value="Mrs.">Mrs.</MenuItem>
                  <MenuItem value="Ms.">Ms.</MenuItem>
                </TextField>
              </div>
              <div className="mb-3">
                <TextField
                  label="First Name"
                  name="firstName"
                  //  required
                  onChange={participant3Change}
                  fullWidth
                />
              </div>
              <div className="mb-3">
                <TextField
                  label="Last Name"
                  fullWidth
                  //  required
                  name="lastName"
                  onChange={participant3Change}
                />
              </div>
              <div className="mb-3">
                <TextField
                  label="Official Email Address"
                  fullWidth
                  //   required
                  name="emailAddress"
                  type="email"
                  onChange={participant3Change}
                />
              </div>
              <div className="mb-3">
                <TextField
                  error={participant3Error}
                  label="Phone Number"
                  fullWidth
                  //    required
                  name="phoneNumber"
                  onChange={(e) => {
                    if (e.target.value.charAt(0) === "0") {
                      participant3Change(e);
                    } else e.target.value = "";
                  }}
                  helperText={
                    participant3Error
                      ? "Fields don't match"
                      : "Format should be 08123456789. Not +234"
                  }
                />
              </div>
              <div className="mb-3">
                <TextField
                  error={participant3Error}
                  label="Confirm Phone Number"
                  fullWidth
                  //  required
                  name="phoneNumber"
                  helperText={participant3Error ? "Fields don't match" : null}
                  onBlur={(e) => {
                    setParticipant3Error(
                      !(e.target.value === participant3.phoneNumber)
                    );
                  }}
                />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center">
            <div className="col-lg-4">
              <Button
                color="success"
                variant="contained"
                type="submit"
                disabled={
                  participant1Error || participant2Error || participant3Error
                }
                fullWidth
                // onClick={handleShow}
              >
                preview
              </Button>
            </div>
          </div>
          <div className="">
            <div
              className="mt-3 rounded shadow-sm p-3"
              style={{ backgroundColor: "#c2d8d7", color: "#41585c" }}
            >
              <div className="mb-1">
                <Stack direction="row" spacing={2}>
                  <div className="d-flex align-items-center">
                    <FontAwesomeIcon icon={faHouse} />
                  </div>
                  <div>
                    <Typography fontSize={16}>{eventBio.venue}</Typography>
                  </div>
                </Stack>
              </div>
              <div className="mb-1">
                <Stack direction="row" spacing={2}>
                  <div className="d-flex align-items-center">
                    <FontAwesomeIcon icon={faCalendar} />
                  </div>
                  <div>
                    <Typography fontSize={16}>{eventBio.date}</Typography>
                  </div>
                </Stack>
              </div>
              <div className="mb-1">
                <Stack direction="row" spacing={2}>
                  <div className="d-flex align-items-center">
                    <FontAwesomeIcon icon={faClock} />
                  </div>
                  <div>
                    <Typography fontSize={16}>7:00 AM</Typography>
                  </div>
                </Stack>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div className="d-none d-lg-block">
        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          centered
          size="xl"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ color: "red" }}>
              Confirm your registration
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ height: "60vh", overflow: "scroll" }}>
              <div className="mb-4">
                <div className="mb-1">
                  <Typography variant="caption">State:</Typography>
                  <Typography variant="h6">{registrationData.state}</Typography>
                </div>
                <div className="mb-1">
                  <Typography variant="caption">Category:</Typography>
                  <Typography variant="h6">
                    {registrationData.category}
                  </Typography>
                </div>
                <div className="mb-1">
                  <Typography variant="caption">Institution:</Typography>
                  <Typography variant="h6">
                    {registrationData.institution}
                  </Typography>
                </div>

                <div className="border-bottom"></div>
              </div>
              <div className="row">
                <div className="col-lg-4">
                  <div className="mb-4">
                    <Typography
                      fontWeight={700}
                      gutterBottom
                      variant="h6"
                      color={"GrayText"}
                    >
                      Participant I
                    </Typography>
                    <div className="mb-1">
                      <Typography variant="caption">Role:</Typography>
                      <Typography variant="h6">{participant1.role}</Typography>
                    </div>
                    <div className="mb-1">
                      <Typography variant="caption">First Name:</Typography>
                      <Typography variant="h6">
                        {participant1.firstName}
                      </Typography>
                    </div>

                    <div className="mb-1">
                      <Typography variant="caption">Last Name:</Typography>
                      <Typography variant="h6">
                        {participant1.lastName}
                      </Typography>
                    </div>
                    <div className="mb-1">
                      <Typography variant="caption">
                        Official Email Address:
                      </Typography>
                      <Typography variant="h6">
                        {participant1.emailAddress}
                      </Typography>
                    </div>
                    <div className="mb-1">
                      <Typography variant="caption">Phone Number:</Typography>
                      <Typography variant="h6">
                        {participant1.phoneNumber}
                      </Typography>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  {registrationData.category !== InstitutionType[4] && (
                    <div className="mb-4 ">
                      <Typography
                        fontWeight={700}
                        gutterBottom
                        variant="h6"
                        color={"GrayText"}
                      >
                        Participant II
                      </Typography>
                      <div className="mb-1">
                        <Typography variant="caption">Role:</Typography>
                        <Typography variant="h6">
                          {participant2.role}
                        </Typography>
                      </div>
                      <div className="mb-1">
                        <Typography variant="caption">First Name:</Typography>
                        <Typography variant="h6">
                          {participant2.firstName}
                        </Typography>
                      </div>
                      <div className="mb-1">
                        <Typography variant="caption">Last Name:</Typography>
                        <Typography variant="h6">
                          {participant2.lastName}
                        </Typography>
                      </div>
                      <div className="mb-1">
                        <Typography variant="caption">
                          Official Email Address:
                        </Typography>
                        <Typography variant="h6">
                          {participant2.emailAddress}
                        </Typography>
                      </div>
                      <div className="mb-1">
                        <Typography variant="caption">Phone Number:</Typography>
                        <Typography variant="h6">
                          {participant2.phoneNumber}
                        </Typography>
                      </div>
                    </div>
                  )}
                </div>
                <div className="col-lg-4">
                  {registrationData.category !== InstitutionType[4] && (
                    <div className="mb-4 ">
                      <Typography
                        fontWeight={700}
                        gutterBottom
                        variant="h6"
                        color={"GrayText"}
                      >
                        Participant III
                      </Typography>
                      <div className="mb-1">
                        <Typography variant="caption">Role:</Typography>
                        <Typography variant="h6">
                          {participant3.role}
                        </Typography>
                      </div>
                      <div className="mb-1">
                        <Typography variant="caption">First Name:</Typography>
                        <Typography variant="h6">
                          {participant3.firstName}
                        </Typography>
                      </div>
                      <div className="mb-1">
                        <Typography variant="caption">Last Name:</Typography>
                        <Typography variant="h6">
                          {participant3.lastName}
                        </Typography>
                      </div>
                      <div className="mb-1">
                        <Typography variant="caption">
                          Official Email Address:
                        </Typography>
                        <Typography variant="h6">
                          {participant3.emailAddress}
                        </Typography>
                      </div>
                      <div className="mb-1">
                        <Typography variant="caption">Phone Number:</Typography>
                        <Typography variant="h6">
                          {participant3.phoneNumber}
                        </Typography>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              startIcon={<ArrowBack />}
              color="error"
              onClick={handleClose}
            >
              Go back
            </Button>
            <LoadingButton
              variant="contained"
              endIcon={<ArrowForward />}
              loading={loading}
              onClick={registerParticipant}
            >
              proceeed to next stage
            </LoadingButton>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}
